"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#fff",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.687 21.284c.784-3.394 2.484-5.091 5.101-5.091.443 1.02 1.18 1.505 2.212 1.454.933.007 1.65-.412 2.153-1.255 1.093.039 4.27.476 5.149 4.892"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89 14.63v1.71m5.579-4.042s1.035-.68 1.073-1.363c.038-.683-.3-.911-.3-.911m-7.616 2.204s-1.035-.679-1.074-1.362c-.038-.684.3-.912.3-.912"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.977 15.574c-1.677.028-3.463-1.899-3.438-3.256.024-1.357 0-2.31 0-2.31s.428-1.115 1.256-1.262c.828-.146 2.01.228 2.8-.444.79-.673 1.335-1.27 1.335-1.27s1.51 1.247 1.554 2.316c.043 1.07-.017 1.936-.043 3.187-.027 1.251-1.787 3.012-3.464 3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.169 14.63v1.71m1.348-4.593s.905-1.585.962-3.73c.058-2.145-2.296-2.557-2.296-2.557s-.866-1.819-3.47-1.252c-2.603.566-3.124 3.14-3.124 3.14s-.23 2.224.872 3.794"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgProfile);
var _default = exports["default"] = Memo;